import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const usePageContent = ({ pageName, defaultsBySection }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [sections, setSections] = useState(defaultsBySection);

  const token = useMemo(() => localStorage.getItem('admin_token'), []);

  const fetchContent = async () => {
    try {
      const res = await axios.get(`${API}/page-content/${pageName}`);
      const next = { ...defaultsBySection };
      res.data.forEach((item) => {
        if (item.section_name && item.content != null) {
          next[item.section_name] = { ...next[item.section_name], ...item.content };
        }
      });
      setSections(next);
    } catch (e) {
      console.error('Error fetching page content:', e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
    // eslint-disable-next-line
  }, []);

  const saveSection = async (sectionName) => {
    setSaving(true);
    try {
      await axios.put(
        `${API}/page-content/${pageName}/${sectionName}`,
        { content: sections[sectionName] },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Saved successfully');
    } catch (e) {
      console.error('Error saving section:', e);
      toast.error('Failed to save');
    } finally {
      setSaving(false);
    }
  };

  return {
    loading,
    saving,
    sections,
    setSections,
    saveSection,
  };
};

export default usePageContent;
